export function setInteractive(image: Phaser.GameObjects.Image) {
  image.scrollFactorX = 0
  image.scrollFactorY = 0
  image.setInteractive()
  image.input.cursor = 'pointer'
}
